import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';

// Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ContactDebug from './components/debug/ContactDebug';

// Pages
import Home from './pages/Home';
import SitiWeb from './pages/services/SitiWeb';
import Ecommerce from './pages/services/Ecommerce';
import SocialMedia from './pages/services/SocialMedia';
import WebMarketing from './pages/services/WebMarketing';
import ConsulenzaSEO from './pages/services/ConsulenzaSEO';
import Branding from './pages/services/Branding';
import IntelligenzaArtificiale from './pages/services/IntelligenzaArtificiale';
import ChiSiamo from './pages/ChiSiamo';
import Contatti from './pages/Contatti';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TerminiServizio from './pages/TerminiServizio';

/**
 * Componente per forzare lo scroll all'inizio della pagina ad ogni cambio di rotta.
 * Ottimizzato per dispositivi mobile e per ignorare lo smooth scroll globale.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Usiamo 'instant' per sovrascrivere lo smooth scroll del CSS durante la navigazione
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    } catch (e) {
      // Fallback per browser più vecchi che non supportano 'behavior: instant'
      window.scrollTo(0, 0);
    }
    
    // Fallback aggiuntivo per garantire lo scroll sui vari elementi radice
    document.documentElement.scrollTo(0, 0);
    if (document.body) document.body.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servizi/realizzazione-siti-web-napoli" element={<SitiWeb />} />
              <Route path="/servizi/realizzazione-ecommerce-napoli" element={<Ecommerce />} />
              <Route path="/servizi/social-media-manager-napoli" element={<SocialMedia />} />
              <Route path="/servizi/web-marketing-napoli" element={<WebMarketing />} />
              <Route path="/servizi/consulenza-seo-napoli" element={<ConsulenzaSEO />} />
              <Route path="/servizi/branding-napoli" element={<Branding />} />
              <Route path="/servizi/intelligenza-artificiale-napoli" element={<IntelligenzaArtificiale />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookie" element={<CookiePolicy />} />
              <Route path="/termini" element={<TerminiServizio />} />
              {/* Catch-all route */}
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <ContactDebug />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;